export const fontFamily = 'Axiforma'
export const fontFamilyBold = 'Axiforma-Bold'

export const font = 'Axiforma'
